import { GoToAccountSettingsCTA } from "./ctas";
export var VatAndTaxIdentifiersIA = function VatAndTaxIdentifiersIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_VAT_AND_OTHER_TAX_INFORMATION(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_UPDATE_YOUR_ACCOUNT_PASSWORD(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var UPDATE_VAT_AND_OTHER_TAX_INFORMATION = function UPDATE_VAT_AND_OTHER_TAX_INFORMATION(strictLocalize) {
  return strictLocalize({
    id: "6vkLOW",
    defaultMessage: [{
      "type": 0,
      "value": "Mise à jour des informations relatives à la TVA et de vos informations fiscales"
    }]
  });
};
var YOU_CAN_UPDATE_YOUR_ACCOUNT_PASSWORD = function YOU_CAN_UPDATE_YOUR_ACCOUNT_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "Xea8Tr",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez mettre à jour vos informations sur la TVA et d'autres informations fiscales dans la section « Informations sur les taxes et les droits d'importation », dans l'onglet « Mon profil » sur la page « Paramètres du compte »."
    }]
  });
};